module.exports = __webpack_public_path__ + "img/select-patient.d7f0c23c.svg";